module.exports = __webpack_public_path__ + "img/Learning_Lifecycle_circle_v2.eb1faa03.png";